import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { ProjectDashboardProject } from '../projectDashboardTypes';

const defaultProjectValue: ProjectDashboardProject = {
  data: undefined,
  status: {
    loading: false,
    error: undefined,
  },
};

/**
 * This context was used as a stop-gap so that we could provide the project data
 * from Reflux down to all the child components.
 *
 * Now that we are using React Query, we can just use the useCurrentProject hook to get the project data,
 * and it's better because we also get async status stuff like loading.
 *
 * This hook will continue to work as expected, but it will be removed soon.
 *
 * @deprecated - use useCurrentProject hook instead.
 */
export const ProjectContext = createContext<ProjectDashboardProject>(defaultProjectValue);

/**
 * This context was used as a stop-gap so that we could provide the project data
 * from Reflux down to all the child components.
 *
 * Now that we are using React Query, we can just use the useCurrentProject hook to get the project data,
 * and it's better because we also get async status stuff like loading.
 *
 * This hook will continue to work as expected, but it will be removed soon.
 *
 * @deprecated - use useCurrentProject hook instead.
 */
export const useProject = () => {
  return useContext(ProjectContext);
};

type ProjectProviderProps = {
  children: ReactNode;
  value: ProjectDashboardProject;
};

/**
 * This context was used as a stop-gap so that we could provide the project data
 * from Reflux down to all the child components.
 *
 * Now that we are using React Query, we can just use the useCurrentProject hook to get the project data,
 * and it's better because we also get async status stuff like loading.
 *
 * This hook will continue to work as expected, but it will be removed soon.
 *
 * @deprecated - use useCurrentProject hook instead.
 */
export const ProjectProvider = ({ children, value }: ProjectProviderProps) => (
  <ProjectContext.Provider value={value}>
    {children}
  </ProjectContext.Provider>
);

export default ProjectProvider;
